import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useUser } from '@/features/auth/hooks';
import type { User } from '@/features/auth/types';

export const WIRE_PLAN_CHANGE_PATH = '/billing/checkout/wire';

// Bank-transfer subscriptions come back from the API as provider 'wire', which
// ActiveSubscription['provider'] doesn't list. The price endpoint only accepts
// 'stripe' and 'paypal', so a self-serve page for these customers never loads.
const isWireSubscription = (user: User) => {
  const provider: string | undefined = user.activeSubscription?.provider;

  return provider === 'wire';
};

export const RedirectWireSubscription = ({
  children,
}: {
  children: ReactNode;
}) => {
  const location = useLocation();
  const user = useUser();

  if (isWireSubscription(user)) {
    return (
      <Navigate to={WIRE_PLAN_CHANGE_PATH} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export const RequireWireSubscription = ({
  children,
}: {
  children: ReactNode;
}) => {
  const location = useLocation();
  const user = useUser();

  if (!isWireSubscription(user)) {
    return (
      <Navigate to="/billing/pricing" state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};
